import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=1ec994a6&scoped=true&"
import script from "./Reporting.vue?vue&type=script&lang=js&"
export * from "./Reporting.vue?vue&type=script&lang=js&"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=1ec994a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec994a6",
  null
  
)

export default component.exports